export default __webpack_public_path__ + "static/media/logo.ee6f534d.svg";